import { Base } from './base.model';

export class DocumentType extends Base {
  public name: string;
  public isPrivate: boolean;
}
